export function Separator({ className = "" }) {
  return <hr className={`my-4 ${className}`} />;
}
